import { PageHero, Prose, Clause } from "@/components/site/PageParts";
import { CONTACT } from "@/lib/site";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHero
        index="G/"
        overline="Privacy Policy"
        titleLines={["Your privacy,", <>by <span className="italic text-oxblood">design</span></>]}
        intro="How Interlaced Social LLC collects, uses, and protects your information."
      />
      <Prose>
        <p className="text-ink-soft text-lg leading-relaxed">
          This Privacy Policy explains how Interlaced Social LLC ("we", "us")
          handles information in connection with Doublelist. By using the
          platform, you agree to the practices described here. Last updated June 2026.
        </p>

        <Clause number="1" title="Information we collect">
          <p>
            We collect only what we need to operate a safe, adults-only platform:
            information you provide (such as profile details and messages),
            limited technical data (such as device and log information), and any
            reports you submit. We do not require more than necessary.
          </p>
        </Clause>

        <Clause number="2" title="Age requirement">
          <p>
            Doublelist is strictly for adults 18 and older. We do not knowingly
            collect information from minors. If we learn that a minor has used the
            platform, we remove the account and associated data.
          </p>
        </Clause>

        <Clause number="3" title="How we use information">
          <p>
            We use information to provide and secure the service, enforce our
            Community Rules, prevent illegal activity and abuse, respond to your
            requests, and comply with legal obligations.
          </p>
        </Clause>

        <Clause number="4" title="We do not sell your data">
          <p>
            We do not sell your personal information. We share data only with
            service providers who help us operate the platform, or where required
            by law or to protect the safety of our community.
          </p>
        </Clause>

        <Clause number="5" title="Data security & retention">
          <p>
            We apply reasonable safeguards to protect your information and retain
            it only as long as necessary for the purposes described here or as
            required by law.
          </p>
        </Clause>

        <Clause number="6" title="Your choices">
          <p>
            You may access, update, or request deletion of your information,
            subject to legal limits. To exercise your rights, contact us at{" "}
            <a href={`mailto:${CONTACT.email}`} className="text-oxblood underline">{CONTACT.email}</a>.
          </p>
        </Clause>

        <Clause number="7" title="Contact">
          <p>
            Interlaced Social LLC · {CONTACT.address} · {CONTACT.phone} ·{" "}
            <a href={`mailto:${CONTACT.email}`} className="text-oxblood underline">{CONTACT.email}</a>
          </p>
        </Clause>
      </Prose>
    </div>
  );
}
